import React from 'react'
import MomentDays from '../templates/moment/MomentDays'
import Container from '../templates/app/Container'

export default ({ userId, isScrollable }) => (
  <TimelineContainer>
    <MomentDays userId={userId} />
  </TimelineContainer>
)

const TimelineContainer = Container.extend`
  padding: 60px 0;
`



// WEBPACK FOOTER //
// ./src/components/pages/MomentTimelinePage.js